/**
 * Чисті хелпери статусу документа eObig -> ярлик/клас для UI.
 *
 * Написано у стилі CommonJS навмисно: модуль споживається і Vue-застосунком
 * (через webpack-інтероп), і standalone node-тестами (`require`) без збірки.
 */

// Внутрішній UI-статус -> як показати оператору
const STATUS_MAP = {
  none:          { label: 'Не в eObig',          cls: 'bg-secondary' },
  uploaded:      { label: 'Завантажено',         cls: 'bg-info' },
  sent:          { label: 'Надіслано клієнту',   cls: 'bg-warning' },
  awaiting_sign: { label: 'Очікує підпис',       cls: 'bg-warning' },
  signed:        { label: 'Підписано',           cls: 'bg-success' },
  failed:        { label: 'Помилка',             cls: 'bg-danger' },
};

/**
 * Повертає { label, cls } для внутрішнього UI-статусу.
 * @param {string} status
 */
function mapEobigStatus(status) {
  return STATUS_MAP[status] || STATUS_MAP.none;
}

/**
 * Мапінг статусу документа eObig (draft|shared|signed|trashed|deleted)
 * у внутрішній UI-статус. Має збігатися з бекендом (Eobig::mapStatus).
 * @param {string} docStatus
 */
function fromEobigDocStatus(docStatus) {
  switch (docStatus) {
    case 'draft':   return 'uploaded';
    case 'shared':  return 'sent';
    case 'signed':  return 'signed';
    case 'trashed':
    case 'deleted': return 'none';
    default:        return 'uploaded';
  }
}

module.exports = { STATUS_MAP, mapEobigStatus, fromEobigDocStatus };
